import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { IObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IFiber } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';
@Injectable({
  providedIn: 'root',
})
export class FiberService extends CommonService<IFiber, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_REMOVE;
  public override mergeFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_MERGE;
  public override updateFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_UPDATE;
  public override getKeysFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_GETKEYS;
  public override getFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_GET;
  public override getAllFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_GETALL;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_FIBER_INSERT;

  constructor(functions: Functions) {
    super(functions);
  }
}
